import { FC, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useHeaderStore } from "../parts/CommonHeader";
import { LoginDialog } from "../parts/LoginDialog";
import { Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { getModalOffset } from "../services/ScreenUtil";
import { ToastBar, Toaster } from "react-hot-toast";
import { postWithoutSign } from "../services/ApiHandler";
import { getReferrer, saveToken } from "../services/CookieHandler";

export const ProxyLoginPage: FC = () => {
  const [loginDialogOpened, { open: openLoginDialog, close: closeLoginDialog }] = useDisclosure(false);
  const { screenWidth } = useHeaderStore();
  const [accountId, setAccountId] = useState('');

  async function login(accountId: String) {
    var param = { AccountId: accountId };
    var response = await postWithoutSign<string>('ProxyLogin/Login', param);
    if(response.code === 1) {
      saveToken(response.data!);
      window.location.href = '/image-generation';
    }
  }

  return <>
    <div>
      <input type="text" placeholder="" onChange={(e) => setAccountId(e.target.value)} />
      <button onClick={() => login(accountId)}>login</button>
    </div>
  </>;
}